const safeJSONParse = (str, respondWithOnFail = false) => {
  if (typeof str !== 'string') {
    return respondWithOnFail;
  }
  try {
    return JSON.parse(str);
  } catch (e) {
    console.error('JSON parsing failed:', e);
    return respondWithOnFail;
  }
};

export default safeJSONParse;
